// actions/studentActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllStudents =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_STUDENTS_REQUEST" });
      const { data } = await api.get("/students", { params });
      dispatch({ type: "ALL_STUDENTS_SUCCESS", payload: data.students });
    } catch (err) {
      dispatch({
        type: "ALL_STUDENTS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

export const getStudent = (id) => async (dispatch) => {
  try {
    dispatch({ type: "STUDENT_DETAIL_REQUEST" });
    const { data } = await api.get(`/students/${id}`);
    dispatch({ type: "STUDENT_DETAIL_SUCCESS", payload: data.student });
    dispatch({
      type: "STUDENT_SIBLINGS_SUCCESS",
      payload: data.siblings || [],
    });
    return data;
  } catch (err) {
    dispatch({
      type: "STUDENT_DETAIL_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createStudent = (studentData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_STUDENT_REQUEST" });
    const { data } = await api.post("/students", studentData);
    dispatch({ type: "CREATE_STUDENT_SUCCESS", payload: data.student });
  } catch (err) {
    dispatch({
      type: "CREATE_STUDENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const bulkUploadStudents = (students) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_STUDENT_REQUEST" });
    const { data } = await api.post("/students/bulk-upload", { students });
    dispatch({ type: "CREATE_STUDENT_SUCCESS", payload: data.results });
  } catch (err) {
    dispatch({
      type: "CREATE_STUDENT_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const searchParentByPhone = (phone) => async (dispatch) => {
  try {
    const { data } = await api.get("/students/search-parent", {
      params: { phone },
    });
    return data;
  } catch (err) {
    throw err;
  }
};

export const getMyChild = () => async (dispatch) => {
  try {
    dispatch({ type: "MY_CHILD_REQUEST" });
    const { data } = await api.get("/students/my-child");
    dispatch({ type: "MY_CHILD_SUCCESS", payload: data.student });
  } catch (err) {
    dispatch({
      type: "MY_CHILD_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const getMyChildren = () => async (dispatch) => {
  try {
    dispatch({ type: "MY_CHILDREN_REQUEST" });
    const { data } = await api.get("/students/my-children");
    dispatch({ type: "MY_CHILDREN_SUCCESS", payload: data.students });
    return data.students;
  } catch (err) {
    dispatch({
      type: "MY_CHILDREN_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

// Which of the parent's (possibly multiple) children the UI is currently
// showing data for. Every parent page should read this instead of
// assuming a single child.
export const setSelectedChild = (studentId) => (dispatch) => {
  dispatch({ type: "SET_SELECTED_CHILD", payload: studentId });
};
